module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 class="module-title">'+
((__t=( i18n.tc( "UnitTechnical", "Technical" ) ))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div data-region="technical-container"><dl><dt>'+
((__t=( i18n.tc("Unit", "Device ID:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( id ))==null?'':__t)+
'</dd><dt class="green">'+
((__t=( i18n.tc( "UnitTechnical", "SIM-number:" ) ))==null?'':__t)+
'</dt> ';
 if ( iccid ) { 
__p+=' <dd class="success">'+
((__t=( iccid ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dd class="error">'+
((__t=( i18n.tc( "UnitTechnical", "Not found" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' <dt>'+
((__t=( i18n.tc( "UnitTechnical", "IP-address:" ) ))==null?'':__t)+
'</dt> ';
 if ( ipAddress ) { 
__p+=' <dd class="success">'+
((__t=( ipAddress ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dd class="error">'+
((__t=( i18n.tc( "UnitTechnical", "Not found" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' <dt>'+
((__t=( i18n.tc( "UnitTechnical", "Active number:" ) ))==null?'':__t)+
'</dt> ';
 if ( activeSim ) { 
__p+=' <dd class="success">'+
((__t=( activeSim ))==null?'':__t)+
'</dd><dt>'+
((__t=( i18n.tc( "UnitTechnical", "Chipsim:" ) ))==null?'':__t)+
'</dt> ';
 if ( isChipSim ) { 
__p+=' <dd class="success">'+
((__t=( i18n.tc( "UnitTechnical", "Yes" ) ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dd class="success">'+
((__t=( i18n.tc( "UnitTechnical", "No" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 } else { 
__p+=' <dd class="error">'+
((__t=( i18n.tc( "UnitTechnical", "Not found" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl></div></div></div>';
}
return __p;
};
